import { render, staticRenderFns } from "./apartment-search-result.vue?vue&type=template&id=5de85a48&scoped=true&"
import script from "./apartment-search-result.ts?vue&type=script&lang=ts&"
export * from "./apartment-search-result.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-search-result.scss?vue&type=style&index=0&id=5de85a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de85a48",
  null
  
)

export default component.exports